import loadable from "@loadable/component"

// Load a component before the render proccess
const LoadableIntroduction = loadable(() => import("./Introduction"))
const LoadableNavbar = loadable(() => import("./Navbar"))
const LoadableServices = loadable(() => import("./Services"))
const LoadableProducts = loadable(() => import("./Products"))
const LoadableTechnology = loadable(() => import("./Technology"))
const LoadableContact = loadable(() => import("./Contact"))
const LoadableAboutUs = loadable(() => import("./AboutUs"))
const LoadableBanner = loadable(() => import("./Banner"))
const LoadableFooter = loadable(() => import("./Footer"))
const LoadableScrollTop = loadable(() => import("./ScrollTop"))

export {
  LoadableIntroduction,
  LoadableNavbar,
  LoadableServices,
  LoadableProducts,
  LoadableTechnology,
  LoadableAboutUs,
  LoadableContact,
  LoadableBanner,
  LoadableFooter,
  LoadableScrollTop,
}
